// Third party
import { combineReducers } from 'redux';
import { iopsApi } from 'api';

// All reducers
import { default as user } from './user';
import { default as auth } from './auth/auth';
import { default as cart } from './cart';
import { default as help } from './help';
import { default as report } from './report';
import { default as tanStackTableFilterOptions } from './tanStackTable';
import { prosealApi } from 'common/pages/fleetV2/machine/proseal/api';
import { dsiApi } from 'common/pages/fleetV2/machine/dsi/api';

const reducers = combineReducers({
  user,
  [iopsApi.reducerPath]: iopsApi.reducer,
  [prosealApi.reducerPath]: prosealApi.reducer,
  [dsiApi.reducerPath]: dsiApi.reducer,
  tokens: auth,
  cart,
  help,
  report,
  tanStackTableFilterOptions
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
